var _a;
import { mapValues } from 'lodash-es';
import * as codeLanguages from '../constants/code';
import * as platforms from '../constants/platform';
import { getPlatform } from './project';
export function getSelectedElementCode(state) {
    var selectedItemIndex = state.handoff.selectedItemIndex;
    // index of flatCanvas isn't the same as code as flatCanvas omits some items so they don't render
    var selectedItemId = state.handoff.flatCanvas[selectedItemIndex].id;
    var itemCode = mapValues(state.code.code, function (code) { return code[selectedItemId]; });
    return {
        code: itemCode,
        requestStatus: state.code.requestStatus,
        currentLang: getCurrentLanguage(state),
    };
}
export function getCurrentLanguage(state) {
    return state.code.currentLang;
}
var codeLangMap = (_a = {},
    _a[platforms.ANDROID] = codeLanguages.ANDROID,
    _a[platforms.WEB] = codeLanguages.CSS,
    _a[platforms.IOS] = codeLanguages.SWIFT,
    _a[platforms.WATCHOS] = codeLanguages.SWIFT,
    _a);
export function getDefaultCodeLang(state) {
    var platform = getPlatform(state);
    return codeLangMap[platform];
}
